import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LocizeBackend from 'i18next-locize-backend';
import ChainedBackend from 'i18next-chained-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import { Locale } from 'types/locale';

const locale: Locale = JSON.parse(localStorage.getItem('locale'));

i18n
  .use(ChainedBackend)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'nb', 'sv', 'fi'],
    fallbackLng: 'en',
    lng: locale?.language || 'en',
    debug: true,
    returnEmptyString: false,
    detection: {
      order: ['navigator'],
      caches: [],
    },
    backend: {
      backends: [
        LocizeBackend,
        resourcesToBackend(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (language: any, namespace: any) =>
            import(`../assets/locales/${language}/${namespace}.json`)
        ),
      ],
      backendOptions: [
        {
          projectId: process.env.LOCIZE_PROJECTID,
          version: 'production',
          referenceLng: 'en',
          cdnType: 'pro',
        },
      ],
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
